import { Button } from '@/components/ui/button'
import { CheckCircle2 } from 'lucide-react'
import type { ReactNode } from 'react'
import { FormSettingsDialog } from './FormSettingsDialog'

export function CompletionPageSettings({ trigger }: { trigger?: ReactNode }) {
  return (
    <FormSettingsDialog
      trigger={
        trigger ?? (
          <Button className="w-full" variant="outline">
            <CheckCircle2 className="size-4" />
            問卷設定
          </Button>
        )
      }
    />
  )
}
